<template>
  <div class="heartbeat">
    <!-- 心跳检测弹窗 -->
    <mu-dialog :open.sync="isHeartBeat" max-width="300px" :overlay-close="false" :append-body="false" :overlay="false">
      <p class="dl-title" slot="title">温馨提示</p>
      <div class="dl-content mb20">
        <p>{{ msge }}</p>
      </div>
      <div class="dl-footer" :class="Object.keys(button).length >= 2 || button.indexOf('btn_submit_logout') > -1 ? '' : 'dl-f-center'">
        <mu-button v-if="button.indexOf('btn_wait_autonym') > -1" :color="'#EEEEEE'" :text-color="themeConfig.dark" @click="isHeartBeat = false">稍后实名</mu-button>
        <div v-if="button.indexOf('btn_autonym') > -1">
          <mu-button v-if="button.indexOf('btn_submit_logout') > -1" :color="themeConfig.dark" :text-color="'#EEEEEE'" @click="goRealName">立即实名</mu-button>
          <mu-button v-else :color="themeConfig.dark" :text-color="'#EEEEEE'" @click="goRealName('no')">立即实名</mu-button>
        </div>
        <mu-button v-if="button.indexOf('btn_submit_logout') > -1" :color="themeConfig.dark" :text-color="'#EEEEEE'" @click="logOff">确认</mu-button>
        <mu-button v-if="button.indexOf('btn_submit_close_dialog') > -1" :color="themeConfig.dark" :text-color="'#EEEEEE'" @click="isHeartBeat = false">确认</mu-button>
      </div>
    </mu-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import md5 from 'js-md5'
import qs from 'qs'
import { logout } from '@/api/login'
import { newPromise, removeToken, getToken } from '@/utils'
import Cookies from 'js-cookie'

export default {
  name: 'heartbeat',
  props: {
    hasHeartbeat: {
      type: Boolean,
      default: false
    },
    rechargeObj: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    hasHeartbeat (val) {
      if (val) {
        this.isHeart = true
        this.getHeart()
        this.$emit('update:hasHeartbeat', false)
      }
    },
    rechargeObj (val) {
      if (val && val.show === 1) {
        this.isHeartBeat = true
        this.button = val.button
        this.msge = val.msge
      }
    }
  },
  computed: {
    ...mapGetters([
      'init',
      'status',
      'idfa',
      'themeConfig'
    ])
  },
  methods: {
    createHToken () {
      this.sTime = this.hTime = parseInt(new Date().getTime() / 1000)
      this.hToken = Math.random().toString(36).substr(2)
      this.isFirst = true
    },
    getSign () {
      const appKey = `xinxin#${this.init.identity}`
      this.signTime = parseInt(new Date().getTime() / 1000)
      this.sign = md5(appKey + this.signTime)
    },
    getHeart () {
      const gameId = this.init.identity
      const uid = this.status.uid
      if (Cookies.get(`htoken_${gameId}_${uid}`)) {
        this.hToken = Cookies.get(`htoken_${gameId}_${uid}`).split('_')[0]
        this.sTime = Cookies.get(`htoken_${gameId}_${uid}`).split('_')[1]
        this.hTime = parseInt(new Date().getTime() / 1000)
      } else {
        this.createHToken()
      }
      Cookies.set(`htoken_${gameId}_${uid}`, `${this.hToken}_${this.sTime}`, { expires: new Date(new Date().getTime() + 5 * 60 * 1000) })
      this.getSign()
      const obj = {
        hToken: this.hToken,
        sTime: this.sTime,
        hTime: this.hTime,
        hSec: this.init.heartbeat_interval,
        appid: this.init.identity,
        os: window.mobileInfo.os,
        devicebrand: window.mobileInfo.phone, //  待确认
        model: window.mobileInfo.model,
        session_id: getToken(),
        uuid: this.idfa, //  待确认
        username: this.status.username,
        uid: this.status.uid,
        agent_id: this.$route.query.agent_id || 100000,
        placeid: this.$route.query.placeid || 100000,
        sign: this.sign,
        time: this.signTime,
        fcm: 1
      }
      this.isFirst = false
      axios('https://bdlogs.693975.com/sdk/heart', { method: 'post', data: qs.stringify(obj) }).then(res => {
        if (res.data.ret === 1) {
          // 弹窗
          if (res.data.info.is_sm_pop !== undefined && res.data.info.is_sm_pop === 1) {
            this.msge = res.data.info.sm_message
            this.button = res.data.info.sm_buttons
            this.$parent.open = false
            this.isHeartBeat = true
          }
          // 清除心跳定时器
          if (res.data.info.use_heart !== undefined && res.data.info.use_heart === 0) {
            this.isHeart = false
          }
        }
      }).catch(() => {}).finally(() => {
        setTimeout(() => {
          this.isHeart && this.getHeart()
        }, 60000)
      })
    },
    showDialog (info) {
      this.msge = info.sm_message
      this.button = info.sm_buttons
      this.isHeartBeat = true
    },
    // 跳转立即实名
    goRealName (type) {
      this.$emit('heartbeatFunc', 'realName')
      if (type === 'no') {
        this.isHeartBeat = false
      }
    },
    // 退出登陆
    async logOff () {
      this.logOffLoading = true
      const res = await newPromise(logout)
      this.logOffLoading = false
      if (res.ret === 1) {
        const gameId = this.init.identity
        const uid = this.status.uid
        Cookies.remove(`htoken_${gameId}_${uid}`)
        removeToken()
        try {
          sessionStorage.setItem('username', this.status.username)
        } catch (e) {}
        location.reload()
      }
    },
    // 关闭窗口
    closeIsHeartBeat () {
      this.isHeartBeat = false
    }
  },
  data () {
    return {
      isHeartBeat: false,
      hToken: '',
      sTime: null,
      hTime: null,
      msge: '',
      sign: '',
      signTime: null,
      button: [],
      isHeart: false,
      logOffLoading: false,
      isFirst: false //  是否第一次请求
    }
  }
}
</script>

<style lang="less" scoped>
.dl-title {
  font-size: 20px;
  color: #333;
  width: 100%;
  font-weight: 600;
  text-align: center;
  position: relative;
  .back-icon {
    font-size: .56rem;
    color: #CCCBCA;
    position: absolute;
    left: 4px;
    top: 3px;
  }
}
.dl-content {
  font-size: .2rem;
  color: #333;
  line-height: .36rem;
  letter-spacing: .06rem;
  .dl-c-title {
    padding-bottom: .2rem;
    font-size: .26rem;
    font-weight: 800;
  }
}
.dl-footer {
  display: flex;
  justify-content: space-between;
}
.dl-f-center {
  justify-content: center;
}
.mb20 {
  margin-bottom: .2rem;
}
.heartbeat {
  /deep/ .mu-dialog-wrapper {
    z-index: 20141200!important;
  }
}
@media screen and (max-width:450px) {
  .dl-title {
    font-size: .36rem;
  }
}
</style>
